import React from 'react';
import ReactDOM from 'react-dom';
import './Styling/templateBuilder.css';
import TDEClient from './Components/TDEClient';

ReactDOM.render( < TDEClient /> , document.getElementById('window'));

